<template>
  <div>
    <div class="close-btn">
      <router-link to="/mainStoryView">
        <i class="fa fa-times"></i>
      </router-link>
    </div>
    <div class="panel-wrapper">
      <div class="col">
        <div class="logic-wrapper inspector-wrap">
          <div class="d-inline-flex mb-4">
            <h4 class="mr-3 mb-0">
              Global Logic List
            </h4>
            <div class="d-flex align-items-center">
        <span class="cursor-pointer" @click="addNewGlobalLogic()">
          <img
            src="~@/assets/addplus_icon.svg"
            width="20"
            class="heading-icon"
          />
          Add new condition
        </span>
            </div>
          </div>
          <div class="col-8 p-0">
            <div v-for="(item, index) in global_logic_list" :key="index"
                 class="mb-3 list-wrapper d-flex align-items-center">
              <div class="col-10">
                {{ item.title }}
              </div>
              <div class="col-2 text-right">
                <button class="btn btn-outline-primary btn-sm mr-2"
                        @click="editGlobalLogic(item)"
                >
                  <i class="fa fa-pencil"></i>
                </button>
                <button class="btn btn-outline-danger btn-sm"
                        @click="deleteGlobalLogic(item)"
                >
                  <i class="fa fa-trash"></i>
                </button>
              </div>


            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  components: {},
  data () {
    return {
      global_logic_list: [
        {
          id: '1',
          title: 'Global Logic list title 1'
        },
        {
          id: '2',
          title: 'Global Logic list title 2'
        },
        {
          id: '3',
          title: 'Global Logic list title 3'
        }
      ]
    }
  },
  created () {
  },
  mounted () {
    console.log('this.$store.selectedLogic', this.$store.state.selectedLogic)
  },

  methods: {
    addNewGlobalLogic () {
      this.$router.push({name: 'addGlobalLogic'})
    },
    editGlobalLogic (item) {
      this.$router.push({name: 'addGlobalLogic'})
    },
    deleteGlobalLogic (item) {
      console.log(item)
    }
  },
  watch: {},
  computed: {}
}
</script>



// WEBPACK FOOTER //
// src/components/v2/story-edit-view/global-logic-components/globalLogicList.vue